import logger from '@eventbrite/client-logger';
import { getWindowObject, HAS_WINDOW } from '@eventbrite/feature-detection';
import { addDimensions } from '@eventbrite/site-analytics';
import { $FixMe } from '@eventbrite/ts-utils';
import { SplitFactory } from '@splitsoftware/splitio';
import {
    getSplitNames,
    getTreatments,
    initSplitSdk,
} from '@splitsoftware/splitio-redux';
import { Dispatch } from 'redux';
import { getActiveFFsFromCore } from '../selectors/app';
import {
    getEventCountryCode,
    getEventOrganizationId,
} from '../selectors/event';
import { isSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import {
    getCoreTaxSplitioClientConfig,
    getSplitioClient,
} from '../utils/splitio';

export const initializeSplitioSdk =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const {
            app: {
                isProd,
                splitIOProdKey,
                event: { id: eventId },
            },
        } = getState();

        const countryCode = getEventCountryCode(getState());
        const organizationId = getEventOrganizationId(getState());

        // Don't initialize SDK if there is no prod key (eg. unit tests)
        if (!splitIOProdKey) return;

        await dispatch(
            initSplitSdk({
                config: getSplitioClient(
                    eventId,
                    isProd ? splitIOProdKey : null,
                ),
            }) as $FixMe,
        );

        const splitNames = getSplitNames();

        // Apply attributes to evaluate splits
        dispatch(
            getTreatments({
                splitNames: splitNames,
                attributes: { eventId, countryCode, organizationId },
            }) as any,
        );

        // Send split values to analytics
        const state = getState();
        const activeFFsFromCore = getActiveFFsFromCore(state);
        const activeSplits = splitNames.flatMap((name) => {
            const value = isSplitTreatmentEnabled(state, name);
            return value ? [name] : [];
        });
        addDimensions({
            experimentId: [...activeSplits, ...activeFFsFromCore]
                .sort()
                .join(','),
        });

        return Promise.resolve();
    };

interface SplitIOClient extends SplitIO.IClient {
    isSDKReady?: boolean;
}

export const initializeCoreTaxSplitioSdk = (
    eventId: string,
    isProd: boolean,
) => {
    if (!HAS_WINDOW) {
        return;
    }

    if (!getWindowObject('splitIOClients')) {
        window.splitIOClients = new Map<string, SplitIOClient>();
    }

    let client: SplitIOClient;
    try {
        client = SplitFactory(
            getCoreTaxSplitioClientConfig(eventId, isProd),
        ).client();
    } catch (error) {
        logger.error('Error initializing the core-tax Split.IO Client', {
            error,
        });
        return;
    }

    window.splitIOClients.set('core-tax', client);
};
